<div *appIsGranted="this.permissions">
  <ng-content></ng-content>
</div>
